export const state = {
  modelCurtain1: '',
  modelCurtain2: '',
  modelCurtain3: '',
  modelCurtain4: '',
  modelCurtain5: '',
  modelCurtain6: '',
  kitCurtains1: [
    { artikul: 'xxxx-xxx-xx', name: 'Софт, синий', price: 2900, withTulle: false, src: '/img/soft_blue.png', flex: 4 },
    { artikul: 'xxxx-xxx-yy', name: 'Софт, коричневый', price: 2900, withTulle: false, src: '/img/soft_brown.png', flex: 4 },
    { artikul: 'xxxx-xxx-zz', name: 'Софт, зеленый', price: 2900, withTulle: false, src: '/img/soft_green.png', flex: 4 },
    { artikul: 'xxxx-xxx-cc', name: 'Софт, бежевый', price: 2900, withTulle: false, src: '/img/soft_light_brown.png', flex: 4 },
    { artikul: 'xxxx-xxx-vv', name: 'Софт, серый', price: 2900, withTulle: false, src: '/img/soft_silver.png', flex: 4 },
    { artikul: 'xxxx-xxx-bb', name: 'Софт, сиреневый', price: 2900, withTulle: false, src: '/img/soft_purple.png', flex: 4 }
  ],
  kitCurtainsKids: [
    { artikul: 'xxxx-xxx-xx', name: 'Города', price: 2900, withTulle: false, src: '/img/cities.png', flex: 4 },
    { artikul: 'xxxx-xxx-yy', name: 'Морена', price: 2900, withTulle: false, src: '/img/morena.png', flex: 4 },
    { artikul: 'xxxx-xxx-zz', name: 'Планета', price: 2900, withTulle: false, src: '/img/planet.png', flex: 4 },
    { artikul: 'xxxx-xxx-cc', name: 'Воздушный шар, синий', price: 2900, withTulle: false, src: '/img/sky_ball.png', flex: 4 },
    { artikul: 'xxxx-xxx-vv', name: 'Воздушный шар, коричневый', price: 2900, withTulle: false, src: '/img/sky_ball2.png', flex: 4 }
  ],
  kitCurtainsKitchen: [
    { artikul: 'xxxx-xxx-xx', name: 'Барбарис, коричневый', price: 2900, withTulle: false, src: '/img/barbaris_brown.png', flex: 4 },
    { artikul: 'xxxx-xxx-yy', name: 'Барбарис, персиковый', price: 2900, withTulle: false, src: '/img/barbaris_orange.png', flex: 4 },
    { artikul: 'xxxx-xxx-zz', name: 'Барбарис, белый', price: 2900, withTulle: false, src: '/img/barbaris_white.png', flex: 4 },
    { artikul: 'xxxx-xxx-cc', name: 'Дояна, коричневый', price: 2900, withTulle: false, src: '/img/doyana_brown.png', flex: 4 },
    { artikul: 'xxxx-xxx-vv', name: 'Дояна, зеленый', price: 2900, withTulle: false, src: '/img/doyana_green.png', flex: 4 },
    { artikul: 'xxxx-xxx-bb', name: 'Дояна, сиреневый', price: 2900, withTulle: false, src: '/img/doyana_purple.png', flex: 4 },
    { artikul: 'xxxx-xxx-vv', name: 'Кармелия, синий', price: 2900, withTulle: false, src: '/img/karmeliya_blue.png', flex: 4 },
    { artikul: 'xxxx-xxx-bb', name: 'Кармелия, сиреневый', price: 2900, withTulle: false, src: '/img/karmeliya_purple.png', flex: 4 }
  ],
  costStep3WidthWindow1: null
}

export const getters = {

}

export const mutations = {
  updateModelCurtain1 (state, modelCurtain1) {
    state.modelCurtain1 = modelCurtain1
  },
  updateModelCurtain2 (state, modelCurtain2) {
    state.modelCurtain2 = modelCurtain2
  },
  updateModelCurtain3 (state, modelCurtain3) {
    state.modelCurtain3 = modelCurtain3
  },
  updateModelCurtain4 (state, modelCurtain4) {
    state.modelCurtain4 = modelCurtain4
  },
  updateModelCurtain5 (state, modelCurtain5) {
    state.modelCurtain5 = modelCurtain5
  },
  updateModelCurtain6 (state, modelCurtain6) {
    state.modelCurtain6 = modelCurtain6
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
